import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
const COLORS = ['#0F766E', '#6366F1', '#F97366', '#FBBF24', '#14B8A6'];
const COUNT = 22;
const pieces = Array.from({
  length: COUNT
}, (_, i) => {
  const angle = i / COUNT * Math.PI * 2 + i % 3 * 0.18;
  const dist = 64 + i * 37 % 48;
  return {
    x: Math.cos(angle) * dist,
    y: Math.sin(angle) * dist - 16,
    rotate: i * 67 % 360,
    color: COLORS[i % COLORS.length],
    round: i % 3 === 0,
    delay: 0.22 + i % 5 * 0.025
  };
});
export function Confetti() {
  const reduce = useReducedMotion();
  if (reduce) return null;
  return <div className="pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-38" data-mp="yaixbtnqxdkb">
      {pieces.map((p, i) => <motion.span key={i} className={`absolute left-1/2 top-1/2 ${p.round ? 'h-2 w-2 rounded-full' : 'h-2.5 w-1.5 rounded-sm'}`} style={{
      backgroundColor: p.color
    }} initial={{
      x: 0,
      y: 0,
      opacity: 0,
      rotate: 0
    }} animate={{
      x: [0, p.x, p.x * 1.08],
      y: [0, p.y, p.y + 26],
      opacity: [1, 1, 0],
      rotate: [0, p.rotate, p.rotate + 90]
    }} transition={{
      duration: 1,
      delay: p.delay,
      ease: 'easeOut',
      times: [0, 0.55, 1]
    }} data-id="element-39" data-mp="12bcnktonv4gd" data-mpi={i} />)}
    </div>;
}